/**
 * Category icon, keyed by the `visualKey` stored on the category.
 *
 * A keyed registry rather than a component per category: creating a category is
 * content work, so a new one picks an existing icon instead of needing a
 * developer. An unknown key falls back to the neutral default, which is what lets
 * content be added ahead of any icon for it.
 *
 * The Material Compliance start page's icons, so an area looks like the module it
 * explains.
 */

import { cn } from "@/lib/utils"
import {
  BookOpen,
  Bot,
  Database,
  Factory,
  Inbox,
  type LucideIcon,
} from "lucide-react"

const VISUALS: Record<string, LucideIcon> = {
  database: Database,
  "supplier-network": Factory,
  certificate: Inbox,
  agent: Bot,
  default: BookOpen,
}

export function visualIcon(visualKey: string): LucideIcon {
  return VISUALS[visualKey] ?? VISUALS.default
}

/** The category's icon beside a row, where the row is outside its own category. */
export function CategoryIcon({
  visualKey,
  className,
}: {
  visualKey: string
  className?: string
}) {
  const Icon = visualIcon(visualKey)
  return (
    <span
      aria-hidden="true"
      className={cn("shrink-0 text-muted-foreground", className)}
    >
      <Icon size={20} strokeWidth={1.25} />
    </span>
  )
}
